var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReloadNeumorphic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 56,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ReloadNeumorphic_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28.579,
  height: 29.373,
  x: 8,
  y: 10,
  fill: "url(#ReloadNeumorphic_svg__b)",
  fillOpacity: 0.6,
  rx: 8
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.25,
  d: "M16 18v3.156M19.156 21.156H16M16.405 20.478A7.98 7.98 0 0 1 23 17a8.001 8.001 0 0 1 0 16c-4.417 0-8-3.583-8-8"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ReloadNeumorphic_svg__b",
  x1: 11,
  x2: 35,
  y1: 35.5,
  y2: 14,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DADADA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ReloadNeumorphic_svg__a",
  width: 48.786,
  height: 54.888,
  x: 0.401,
  y: 0.213,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -2.599,
  dy: -4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.375 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_454_18555"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -2.599
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.44708 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_454_18555",
  result: "effect2_dropShadow_454_18555"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -2.599,
  dy: -4.787
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.539141 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_dropShadow_454_18555",
  result: "effect3_dropShadow_454_18555"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -2.599,
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect3_dropShadow_454_18555",
  result: "effect4_dropShadow_454_18555"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3.899,
  dy: 4.549
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.924
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.8875 0 0 0 0 0.8875 0 0 0 0 0.8875 0 0 0 0.48 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect4_dropShadow_454_18555",
  result: "effect5_dropShadow_454_18555"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3.899,
  dy: 3.639
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.469
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.875 0 0 0 0 0.875 0 0 0 0 0.875 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect5_dropShadow_454_18555",
  result: "effect6_dropShadow_454_18555"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3.899,
  dy: 3.119
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.21
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.875 0 0 0 0 0.875 0 0 0 0 0.875 0 0 0 0.34 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect6_dropShadow_454_18555",
  result: "effect7_dropShadow_454_18555"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3.899,
  dy: 7.019
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.354
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.9 0 0 0 0 0.9 0 0 0 0 0.9 0 0 0 0.67 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect7_dropShadow_454_18555",
  result: "effect8_dropShadow_454_18555"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect8_dropShadow_454_18555",
  result: "shape"
})))));
export default SvgReloadNeumorphic;